// Locales para la URL del router
export enum AppLanguage {
	es = "es",
	en = "en",
	gb = "gb",
}
